import React from 'react';
import {Link} from "react-router-dom";
import IconName from "../../svgLogo/SvgLogo";

const Card = ({product}) => {
    return (
        <div className={"product-card product-card-" + (product.type_card && product.type_card)}>
            <Link to={product.link_product ? product.link_product : "#"} className="card-link">
                <div
                    className={"product-box xpy-10 xp-4 xp-lg-6 xpt-md-12 xpb-md-12 d-flex justify-content-center align-items-center flex-column position-relative"}>
                    <div className="product-price">
                        <span
                            className={product.discount ? "discount persian-number" : "d-none"}>{product.discount ? product.discount + "ت" : ""}</span>
                        <span className="total-price persian-number">{product.price ? product.price + "ت" : "نا موجود"}</span>
                    </div>
                    <div className="product-img xmb-3">
                        <img src={product.img && product.img} className='img-fluid'
                             alt={product.name && product.name}/>
                    </div>
                    <div className="product-text">
                        <h2 className="big-title d-none">{product.persian_name&&product.persian_name}</h2>
                        <h3 className="title">{product.name && product.name}</h3>
                        <div className="score d-none xmt-4">
                            <div className="star-rating" star-score={product.star}>
                                <IconName name="star" className="icon"/>
                                <IconName name="star" className="icon"/>
                                <IconName name="star" className="icon"/>
                                <IconName name="star" className="icon"/>
                                <IconName name="star" className="icon"/>
                            </div>
                            <span className="total-score persian-number">({product.total_score})</span>
                        </div>
                        <div className="info-product d-none xmt-4 xpy-3 xpx-4">
                            <ul className="nav">
                                <li className="nav-item"><IconName name="aspect_ratio"
                                                                   className="icon"/><span>6.5 اینچ</span></li>
                                <li className="nav-item"><IconName name="camera_alt"
                                                                   className="icon"/><span>۱۲ مگاپیکسل</span></li>
                                <li className="nav-item"><IconName name="ram_alt"
                                                                   className="icon"/><span>۴ گیگ</span></li>
                                <li className="nav-item"><IconName name="battery_charging_full"
                                                                   className="icon"/><span>۵۰۰۰ میلی‌آمپر</span></li>
                            </ul>
                        </div>
                        <div className="color-range">
                            <span className="range" style={{background: product.color_range_1}}/>
                            <span className="range" style={{background: product.color_range_2}}/>
                            <span className="range" style={{background: product.color_range_3}}/>
                        </div>
                    </div>
                </div>
            </Link>
            <div
                className="color-range-info d-none">
                <div
                    className="color-box accessories-color-box black active"><span
                    className="color"></span> مشکی
                </div>
                <div className="color-box accessories-color-box white"><span
                    className="color"></span> سفید
                </div>
                <div className="color-box accessories-color-box red"><span
                    className="color"></span> قرمز
                </div>
                <div className="color-box accessories-color-box blue"><span
                    className="color"></span> آبی
                </div>
            </div>
        </div>
    );
};

export default Card;
